var _style, _path, _path2, _path3, _polygon, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 100",
    style: {
      enableBackground: "new 0 0 250 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#264FE6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,41.9v29.8H46V41.9c-0.2-4.5-2.1-6.7-5.7-6.9h-0.8c-3.9,0.1-5.8,2.8-5.8,8v28.6H18.5V43c0-13.7,7-20.9,20.9-21.7h0.8 c5.6,0.4,9.9,1.7,13.4,4c3.3-2.4,7.7-3.7,13.3-4h0.8c14,0.8,20.9,8,20.9,21.7v28.6H73.5V43c0-5.2-1.9-7.9-5.8-8h-0.8 C63.4,35.1,61.5,37.4,61.2,41.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142,36.9c1.4,3.2,2.1,6.7,2.1,10.2v0.5c0,0.1,0,0.4,0,0.5l-0.1,0.8l-5.9,0.1l0,0h-32.5c0.9,5.9,5.9,10.4,12,10.4 c3.2,0,6.3-1.3,8.5-3.5l0.1-0.1l0.1-0.2l0.1-0.1l0.1-0.1l8.2,11.6c-2.1,1.8-4.5,3.2-7.1,4.3c-3.2,1.3-6.6,1.9-10.1,1.9 c-4.6,0-9.1-1.1-13.1-3.3c-4-2.1-7.5-5.4-9.8-9.3c-2.5-4-3.8-8.6-3.7-13.4c0-3.5,0.7-7,2.1-10.2c1.4-3.1,3.4-5.9,5.9-8.3 s5.3-4.3,8.5-5.4c3.2-1.3,6.6-1.9,10.1-1.9c3.4,0,6.9,0.6,10.1,1.9c3.2,1.2,6,3.1,8.5,5.4C138.7,30.9,140.7,33.7,142,36.9z  M117.5,35c-2.1,0-4.1,0.6-5.9,1.7c-1.3,0.8-2.4,1.8-3.3,3h18.6c-0.9-1.2-2-2.1-3.3-3C121.8,35.5,119.7,34.9,117.5,35z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161.2,13.6c-0.7,1.2-1.7,2.1-2.8,2.8c-1.2,0.7-2.6,1.1-4,1.1c-1.4,0-2.7-0.4-3.9-1.1c-1.2-0.7-2.1-1.7-2.8-2.8 c-1.4-2.5-1.4-5.6,0-8c0.7-1.2,1.7-2.1,2.8-2.8s2.5-1.1,3.9-1.1c1.4,0,2.7,0.4,4,1.1c1.2,0.7,2.1,1.7,2.8,2.8c0.7,1.2,1.1,2.6,1.1,4 C162.3,11,161.9,12.3,161.2,13.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "162.2,23.3 162.2,71.7 147.1,71.7 147.1,23.3 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5,4.5h15v67l-15,0.2V4.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,70.7c-2.5,1.1-5.2,1.8-7.9,2.1c-14.9,1.5-22.4-5.6-22.4-21.3V23.3h15.1v27.2c-0.1,2.4,0.6,4.6,2,6.5 c1.4,1.5,3.4,2.4,5.6,2.1c2.1,0.1,4.1-0.7,5.6-2.2c1.4-1.9,2.1-4.1,2-6.5V23.2h15v54.2c0.2,9-5.4,17-14.1,19.8 c-2.8,1.1-5.9,1.5-9,1.5h-2.5c-6.7-0.1-12.2-2.2-16.2-6.3c-2.1-2-3.9-4.5-4.9-7.3l13.6-8c0.2,4.7,4.3,8.5,9,8.5c3.7,0,7-2.2,8.4-5.7 v-0.1l0.1-0.2l0.1-0.4l0.1-0.4c0.1-0.4,0.2-0.7,0.2-1.1c0-0.1,0-0.1,0-0.2V77l0,0L216.5,70.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeily);
export default __webpack_public_path__ + "static/media/meily.e4c5fe93bcd583adf9c39f3d39592d63.svg";
export { ForwardRef as ReactComponent };